import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-location-bpi.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-location-bpi.component.scss?ngResource";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { RecipientSelectComponent } from "../../../../shared/components/recipient-components/recipient-select/recipient-select.component";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { throttleTime } from "rxjs";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { MapService } from "../../../../map/shared/map.service";
import { RequestStatusService } from "../../../../shared/services/request-status/request-status.service";
import { SearchApplicationsService } from "../../../../search-applications/shared/search-applications.service";
import { UserInformationService } from "../../../../shared/services/user/user-information.service";
import { AlertType } from "../../../../shared/models/alert";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { ApiProxyConstants } from "../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../app.config";
import { AppRoutingConstants } from "../../../../app-routing.constants";
import { UrlConstants } from "../../../../shared/constants/url.constants";
import { WktConverterUtils } from "../../../../shared/utils/wkt-converter-utils";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import RecipientUtils from "../../../../shared/utils/recipient-utils";
import { CreateApplicationLocationBpiConstants } from "./create-application-location-bpi.constants";
import { takeUntil } from "rxjs/operators";
import { BuildingPlansInspectorateService } from "../../../../shared/services/modules/building-plans-inspectorate.service";
import { CreateApplicationUtils } from "../../../shared/utils/create-application-utils";
import { ViewApplicationLocationBpiConstants } from "../../../../view-application/modules/bpi/view-application-location-bpi/view-application-location-bpi.constants";
import { LookupConstants } from "../../../../shared/constants/lookup.constants";
import { PopUpComponent } from "../../../../shared/components/pop-up/pop-up.component";
import { MapTools } from "../../../../map/shared/map.tools";
let CreateApplicationLocationBpiComponent = class CreateApplicationLocationBpiComponent extends CreateApplicationViewBaseComponent {
    applicationCreateService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appController;
    mapService;
    mapTools;
    requestStatusService;
    changeDetectorRefs;
    modalService;
    buildingPlansInspectorateService;
    searchApplicationsService;
    userInformationService;
    propertiesForm;
    showPropertyForm = false;
    showDescriptionField = false;
    showReferenceNumber = false;
    detailsFormGroupName = CreateApplicationLocationBpiConstants.DETAILS_FORM_GROUP_NAME;
    applicantFormGroupName = CreateApplicationLocationBpiConstants.APPLICANT_FORM_NAME;
    propertyFormName = CreateApplicationLocationBpiConstants.PROPERTY_FORM_NAME;
    applicantAgentFormGroupName = CreateApplicationLocationBpiConstants.APPLICANT_AGENT_FORM_NAME;
    ownersComponentRef;
    validationMessages = CreateApplicationLocationBpiConstants.VALIDATION_MESSAGES;
    hasBpamsReferenceNumberLabel = CreateApplicationLocationBpiConstants.HAS_BPAMS_REFERENCE_NUMBER_TEXT_PLACEHOLDER;
    descriptionLabel = CreateApplicationLocationBpiConstants.DESCRIPTION_TEXT_PLACEHOLDER;
    bpamsReferenceNumberControl = CreateApplicationLocationBpiConstants.BPAMS_APPLICATION_REFERENCE_NUMBER_CONTROL;
    defaultApplicationType = CreateApplicationLocationBpiConstants.DEFAULT_APPLICATION_TYPE;
    erfNoControl = CreateApplicationLocationBpiConstants.ERF_NO_CONTROL;
    subdivisionControl = CreateApplicationLocationBpiConstants.SUBDIVISION_CONTROL;
    allotmentControl = CreateApplicationLocationBpiConstants.ALLOTMENT_CONTROL;
    farmNoControl = CreateApplicationLocationBpiConstants.FARM_NO_CONTROL;
    sgCodeControl = CreateApplicationLocationBpiConstants.SG_CODE_CONTROL;
    addressControl = CreateApplicationLocationBpiConstants.ADDRESS_CONTROL;
    erfSizeControl = CreateApplicationLocationBpiConstants.ERF_SIZE_CONTROL;
    ownerControl = CreateApplicationLocationBpiConstants.OWNER_CONTROL;
    erfNoTextPlaceHolder = CreateApplicationLocationBpiConstants.ERF_NO_TEXT_PLACEHOLDER;
    hasBpamsReferenceNumberFormControlName = CreateApplicationLocationBpiConstants.HAS_BPAMS_REFERENCE_NUMBER_FORM_CONTROL_NAME;
    bpamsReferenceNumberTextPlaceHolder = CreateApplicationLocationBpiConstants.BPAMS_REFERENCE_NUMBER_TEXT_PLACEHOLDER;
    bpamsReferenceLookupTypeTextPlaceHolder = CreateApplicationLocationBpiConstants.BPAMS_REFERENCE_LOOKUP_TYPE_TEXT_PLACEHOLDER;
    erfNumberLookupTextPlaceHolder = CreateApplicationLocationBpiConstants.ERF_NUMBER_LOOKUP_TEXT_PLACEHOLDER;
    farmNumberLookupTextPlaceHolder = CreateApplicationLocationBpiConstants.FARM_NUMBER_LOOKUP_TEXT_PLACEHOLDER;
    portionNumberLookupTextPlaceHolder = CreateApplicationLocationBpiConstants.PORTION_NUMBER_LOOKUP_TEXT_PLACEHOLDER;
    allotmentLookupTextPlaceHolder = CreateApplicationLocationBpiConstants.ALLOTMENT_LOOKUP_TEXT_PLACEHOLDER;
    subdivisionTextPlaceHolder = CreateApplicationLocationBpiConstants.SUBDIVISION_TEXT_PLACEHOLDER;
    allotmentTextPlaceHolder = CreateApplicationLocationBpiConstants.ALLOTMENT_TEXT_PLACEHOLDER;
    farmNoTextPlaceHolder = CreateApplicationLocationBpiConstants.FARM_NO_TEXT_PLACEHOLDER;
    sgCodeTextPlaceHolder = CreateApplicationLocationBpiConstants.SG_CODE_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = CreateApplicationLocationBpiConstants.ADDRESS_TEXT_PLACEHOLDER;
    erfSizeTextPlaceHolder = CreateApplicationLocationBpiConstants.ERF_SIZE_TEXT_PLACEHOLDER;
    descriptionFormControlName = CreateApplicationLocationBpiConstants.DESCRIPTION_FORM_CONTROL_NAME;
    bpamsApplicationIdFormControlName = CreateApplicationLocationBpiConstants.BPAMS_APPLICATION_ID_FORM_CONTROL_NAME;
    applicationTypeFormControlName = CreateApplicationLocationBpiConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    isVerifiedFormControlName = CreateApplicationLocationBpiConstants.IS_VERIFIED_FORM_CONTROL_NAME;
    applicantFormControlName = CreateApplicationLocationBpiConstants.APPLICANT_FORM_CONTROL_NAME;
    applicantAgentFormControlName = CreateApplicationLocationBpiConstants.APPLICANT_AGENT_FORM_CONTROL_NAME;
    markApplicantAgentNaFormControlName = CreateApplicationLocationBpiConstants.MARK_APPLICANT_AGENT_NA_FORM_CONTROL_NAME;
    propertiesFormControlName = CreateApplicationLocationBpiConstants.PROPERTIES_FORM_CONTROL_NAME;
    centroidFormControlName = CreateApplicationLocationBpiConstants.CENTROID_FORM_CONTROL_NAME;
    bpamsReferenceLookupTypeControl = CreateApplicationLocationBpiConstants.BPAMS_REFERENCE_LOOKUP_TYPE_CONTROL;
    erfNumberLookupControl = CreateApplicationLocationBpiConstants.ERF_NUMBER_LOOKUP_CONTROL;
    farmNumberLookupControl = CreateApplicationLocationBpiConstants.FARM_NUMBER_LOOKUP_CONTROL;
    portionNumberLookupControl = CreateApplicationLocationBpiConstants.PORTION_NUMBER_LOOKUP_CONTROL;
    allotmentLookupControl = CreateApplicationLocationBpiConstants.ALLOTMENT_LOOKUP_CONTROL;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeLabel = SharedConstants.REMOVE_LABEL;
    removePropertyLabel = CreateApplicationLocationBpiConstants.REMOVE_PROPERTY_LABEL;
    ownerLabel = CreateApplicationLocationBpiConstants.OWNER_LABEL;
    copyOwnerLabel = CreateApplicationLocationBpiConstants.COPY_OWNER_LABEL;
    propertyHeadingLabel = CreateApplicationLocationBpiConstants.PROPERTY_HEADING_LABEL;
    ownerDisableFilterBy = true;
    ownerDisableAdd = false;
    ownerDisableEditing = false;
    ownerShowGroupsDropdown = true;
    ownerGroups = [];
    ownerListLabel = "Owner";
    showOnlyPropertyAndZoningLayers = false;
    subdivisionControlRequired = true;
    farmNoControlRequired = true;
    erfNoControlRequired = true;
    applicantGroups = [];
    applicantAgentGroups = [];
    isMapLoaded = false;
    yesNoOptions = LookupConstants.YES_NO;
    verificationMessage = CreateApplicationLocationBpiConstants.VERIFICATION_MESSAGE;
    verifyLabel = CreateApplicationLocationBpiConstants.VERIFY_LABEL;
    bpamsReferenceLookupTypeOptions = CreateApplicationLocationBpiConstants.BPAMS_REFERENCE_LOOKUP_TYPE_OPTIONS;
    lookupTypeBuildingPlanReference = CreateApplicationLocationBpiConstants.LOOKUP_TYPE_BUILDING_PLAN_REFERENCE;
    lookupTypeErfNumber = CreateApplicationLocationBpiConstants.LOOKUP_TYPE_ERF_NUMBER;
    lookupTypeFarmNumber = CreateApplicationLocationBpiConstants.LOOKUP_TYPE_FARM_NUMBER;
    allotmentOptions = [];
    isVerified = false;
    documentsFormGroupName = CreateApplicationLocationBpiConstants.DOCUMENTS_FORM_GROUP_NAME;
    mapComponent;
    modalOptions = {
        size: "lg", centered: true, keyboard: false, backdrop: "static"
    };
    selectedPropertySubscription;
    getTrueCentroidSubscription;
    clearLayerGraphicsSubjectSubscription;
    markStepFormGroupAsTouchedSubscription;
    propertiesFormGroupName = CreateApplicationLocationBpiConstants.PROPERTY_FORM_NAME;
    missingReferenceNumber = CreateApplicationLocationBpiConstants.MISSING_REFERENCE_NUMBER;
    missingLookupDetails = CreateApplicationLocationBpiConstants.MISSING_LOOKUP_DETAILS;
    erfNumberVerificationMessage = CreateApplicationLocationBpiConstants.ERF_NUMBER_VERIFICATION_MESSAGE;
    farmNumberVerificationMessage = CreateApplicationLocationBpiConstants.FARM_NUMBER_VERIFICATION_MESSAGE;
    bpamsModuleName = false;
    constructor(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, appController, mapService, mapTools, requestStatusService, changeDetectorRefs, modalService, buildingPlansInspectorateService, searchApplicationsService, userInformationService) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, searchApplicationsService);
        this.applicationCreateService = applicationCreateService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.mapService = mapService;
        this.mapTools = mapTools;
        this.requestStatusService = requestStatusService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.modalService = modalService;
        this.buildingPlansInspectorateService = buildingPlansInspectorateService;
        this.searchApplicationsService = searchApplicationsService;
        this.userInformationService = userInformationService;
    }
    get getProperties() {
        return this.propertiesForm.get(this.propertiesFormControlName);
    }
    ngOnInit() {
        this.initForm();
        this.restoreUIState();
        this.getMetadata();
        this.subscribeToClearGraphics();
        this.subscribeToCheckFormValidity();
        this.subscribeToProperty();
        this.changeDetectorRefs.detectChanges();
    }
    getPropertyFormControl(controlName) {
        const items = this.propertiesForm.get(this.propertiesFormControlName);
        return items.controls[0]?.get(controlName);
    }
    ngAfterViewInit() {
        this.mapService.actionPropertyEnabled = true;
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
        this.loadPropertyAllotments();
    }
    ngOnDestroy() {
        this.mapService.destroyMap();
    }
    loadMetadata(stepMeta) {
        this.bpamsModuleName = stepMeta.bpamsModuleName;
        this.ownerGroups = stepMeta.ownerGroup;
        this.applicantGroups = stepMeta.applicantGroup;
        this.applicantAgentGroups = stepMeta.applicantAgentGroup;
        this.changeDetectorRefs.markForCheck();
    }
    setNumberToDecimal(formControl, event) {
        //  sets number to two decimal places
        const value = event.target.value;
        const decimalValue = parseFloat(value).toFixed(2);
        formControl.setValue(decimalValue);
    }
    onCopyOwnerToApplicant() {
        const ownersControl = this.propertiesForm.get(this.propertiesFormControlName).controls[0].get(this.ownerControl);
        const selectedOwners = ownersControl.value ? ownersControl.value.filter((x) => x.selected === true) : [];
        if (selectedOwners.length === 0) {
            this.appController.showMessage(CreateApplicationLocationBpiConstants.NO_OWNERS_SELECTED_MESSAGE, AlertType.Warning);
            return;
        }
        if (selectedOwners.length > 1) {
            this.appController.showMessage(CreateApplicationLocationBpiConstants.MULTIPLE_OWNERS_SELECTED_MESSAGE, AlertType.Warning);
            return;
        }
        if (selectedOwners.length === 1) {
            const applicant = RecipientUtils.buildApplicantStringForUserSettings(selectedOwners[0], this.applicantGroups);
            this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").setValue(applicant);
            this.appController.showMessage("Owner data successfully copied", AlertType.Success);
        }
    }
    onVerifyReferenceNumberClicked() {
        const lookupType = this.propertiesForm.get(this.bpamsReferenceLookupTypeControl).value;
        const bpamsReferenceNumber = this.propertiesForm.get(this.bpamsReferenceNumberControl).value;
        const erfNumber = this.propertiesForm.get(this.erfNumberLookupControl).value;
        const farmNumber = this.propertiesForm.get(this.farmNumberLookupControl).value;
        const portionNumber = this.propertiesForm.get(this.portionNumberLookupControl).value;
        const allotment = this.propertiesForm.get(this.allotmentLookupControl).value;
        let canVerify = true;
        let missingMessage = this.missingLookupDetails;
        let verificationMessage = this.verificationMessage;
        const params = {
            lookupType,
            bpamsReferenceNumber: null,
            erfNumber: null,
            farmNumber: null,
            portionNumber: null,
            allotment: null,
            bpamsModuleName: this.bpamsModuleName,
            moduleId: this.appController.selectedModuleID
        };
        if (lookupType === this.lookupTypeBuildingPlanReference) {
            params.bpamsReferenceNumber = bpamsReferenceNumber;
            if (bpamsReferenceNumber === null || bpamsReferenceNumber === undefined || bpamsReferenceNumber === "") {
                canVerify = false;
                missingMessage = this.missingReferenceNumber;
            }
        }
        else if (lookupType === this.lookupTypeErfNumber) {
            params.erfNumber = erfNumber;
            params.allotment = allotment;
            verificationMessage = this.erfNumberVerificationMessage;
            if (erfNumber === null || erfNumber === undefined || erfNumber === "" || allotment === null || allotment === undefined || allotment === "") {
                canVerify = false;
            }
        }
        else if (lookupType === this.lookupTypeFarmNumber) {
            params.farmNumber = farmNumber;
            params.portionNumber = portionNumber;
            params.allotment = allotment;
            verificationMessage = this.farmNumberVerificationMessage;
            if (farmNumber === null || farmNumber === undefined || farmNumber === "" || portionNumber === null || portionNumber === undefined || portionNumber === "" || allotment === null || allotment === undefined || allotment === "") {
                canVerify = false;
            }
        }
        else {
            canVerify = false;
        }
        if (canVerify) {
            const expand = "properties($expand=owners($expand=groups))";
            this.buildingPlansInspectorateService.verifyReferenceNumberObservable(params, expand).subscribe({
                next: value => {
                    this.populateApplication(value.value[0]);
                    this.verificationMessage = verificationMessage;
                    this.appController.showMessage(this.verificationMessage, AlertType.Success);
                    this.isVerified = true;
                    this.changeDetectorRefs.detectChanges();
                },
                error: err => {
                    this.appController.showMessage(err.error, AlertType.Error);
                    this.isVerified = false;
                    this.changeDetectorRefs.detectChanges();
                }
            });
        }
        else {
            this.propertiesForm.markAllAsTouched();
            this.appController.showMessage(missingMessage, AlertType.Warning);
        }
    }
    onHasReferenceNumberChanged(event) {
        const applicationAlreadyHasReferenceNumber = event.target?.value;
        this.resetApplicationComponents();
        if (applicationAlreadyHasReferenceNumber.toLowerCase() === "yes") {
            this.handleApplicationHasReferenceNumber();
        }
        if (applicationAlreadyHasReferenceNumber.toLowerCase() === "no") {
            this.handleApplicationHasNoReferenceNumber();
        }
        this.propertiesForm.get(this.applicationTypeFormControlName).setValue(this.defaultApplicationType);
        this.propertiesForm.get(this.descriptionFormControlName).updateValueAndValidity();
        this.updateReferenceLookupControlsValidity();
        this.propertiesForm.get(this.bpamsApplicationIdFormControlName).updateValueAndValidity();
        this.propertiesForm.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    onReferenceLookupTypeChanged() {
        this.isVerified = false;
        this.propertiesForm.get(this.isVerifiedFormControlName).setValue(null);
        this.propertiesForm.get(this.bpamsApplicationIdFormControlName).setValue(null);
        this.propertiesForm.get(this.bpamsReferenceNumberControl).reset();
        this.propertiesForm.get(this.erfNumberLookupControl).reset();
        this.propertiesForm.get(this.farmNumberLookupControl).reset();
        this.propertiesForm.get(this.portionNumberLookupControl).reset();
        this.propertiesForm.get(this.allotmentLookupControl).reset();
        this.updateReferenceLookupValidators();
        this.changeDetectorRefs.detectChanges();
    }
    subscribeToClearGraphics() {
        this.clearLayerGraphicsSubjectSubscription = this.applicationCreateService.$clearLayerGraphicsSubject.subscribe({
            next: (clearGraphics) => {
                if (clearGraphics) {
                    this.mapComponent.removeGraphicsFromMap("Building plans inspectorate graphics");
                    this.mapTools.sketchGraphicsLayer.removeAll();
                    this.showDescriptionField = false;
                    this.showReferenceNumber = false;
                    this.propertiesForm.get(this.hasBpamsReferenceNumberFormControlName).reset();
                    this.aflaModuleStrategyService.previousApplication = null;
                    this.showPropertyForm = false;
                    this.propertiesForm.get(this.propertiesFormControlName).clear();
                    this.changeDetectorRefs.detectChanges();
                }
            }
        });
    }
    initForm() {
        this.propertiesForm = this.aflaModuleStrategyService.form.get(this.propertiesFormGroupName);
    }
    restoreUIState() {
        const properties = this.getProperties;
        if (properties && properties.length > 0) {
            this.showPropertyForm = true;
        }
        else {
            this.showPropertyForm = false;
        }
    }
    syncMapGeometries() {
        const geometries = [];
        this.propertiesForm.get(this.propertiesFormControlName).controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, "Building plans inspectorate graphics", true);
        }
        else {
            this.mapComponent.removeGraphicsFromMap("Building plans inspectorate graphics");
        }
    }
    subscribeToCheckFormValidity() {
        this.markStepFormGroupAsTouchedSubscription = this.applicationCreateService.$markStepFormGroupAsTouchedSubscription.subscribe({
            next: (formGroupName) => {
                if (formGroupName && this.propertiesForm && formGroupName === this.propertiesFormGroupName) {
                    if (this.propertiesForm)
                        this.propertiesForm.markAllAsTouched();
                    if (this.ownersComponentRef)
                        this.ownersComponentRef.markAllAsTouched();
                    if (this.changeDetectorRefs)
                        this.changeDetectorRefs.markForCheck();
                }
            }
        });
    }
    populateApplication(application) {
        application.applicationType = this.defaultApplicationType;
        application.eLodgementComplete = false;
        application.eLodgementStep = 1;
        this.propertiesForm.get(this.descriptionFormControlName).setValue(application.description);
        this.propertiesForm.get(this.bpamsReferenceNumberControl).setValue(application.referenceNumber);
        this.propertiesForm.get(this.isVerifiedFormControlName).setValue(true);
        this.propertiesForm.get(this.applicationTypeFormControlName).setValue(application.applicationType);
        this.propertiesForm.get(this.bpamsApplicationIdFormControlName).setValue(application.id);
        this.propertiesForm.get(this.descriptionFormControlName).disable();
        this.propertiesForm.get(this.bpamsReferenceNumberControl).disable();
        this.showPropertyForm = false;
        this.changeDetectorRefs.detectChanges();
        this.aflaModuleStrategyService.form.get(this.applicantFormGroupName).updateValueAndValidity();
        this.aflaModuleStrategyService.form.get(this.applicantAgentFormGroupName).get(this.markApplicantAgentNaFormControlName).setValue(false);
        this.aflaModuleStrategyService.form.get(this.applicantAgentFormGroupName).get(this.applicantAgentFormControlName).reset();
        const propertyControl = this.aflaModuleStrategyService.form.get(this.propertyFormName).get(this.propertiesFormControlName);
        propertyControl.clear();
        this.getProperties.clear();
        const propertiesFormArray = this.getProperties;
        application.properties.forEach((property) => {
            property.id = 0;
            const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(property.shape, 102100);
            const geom = JsonUtils.fromJSON(geometryArc);
            const newPropertiesFormGroup = this.createFormGroup(property, geom);
            this.setTrueCentroid(geometryArc, newPropertiesFormGroup, propertiesFormArray, application);
            this.aflaModuleStrategyService.previousApplication = application;
            this.aflaModuleStrategyService.previousApplication.acceptResubmissionDisclaimer = true;
            this.aflaModuleStrategyService.previousApplication.isResubmission = true;
        });
    }
    subscribeToProperty() {
        this.selectedPropertySubscription = this.mapService.$selectedProperty.pipe(throttleTime(3000)).pipe(takeUntil(this._destroy$)).subscribe(property => {
            if (property !== null) {
                this.checkIfPropertyIsAlreadyLoaded(property);
            }
        });
    }
    checkIfPropertyIsAlreadyLoaded(property) {
        const hasReferenceNumberValue = this.propertiesForm.get(this.hasBpamsReferenceNumberFormControlName).value;
        const isVerifiedValue = this.propertiesForm.get(this.isVerifiedFormControlName).value;
        if (hasReferenceNumberValue === null) {
            this.appController.showMessage("Please select if the application has building plan number before adding a property", AlertType.Warning);
            return;
        }
        if (hasReferenceNumberValue === "Yes" && isVerifiedValue) {
            this.appController.showMessage("Please verify the application before adding a property", AlertType.Warning);
            return;
        }
        const title = "Replace property";
        const contentMessage = "An application can only have 1 property. Do you want to replace the current property?";
        const propertyControlArray = this.propertiesForm.get("properties");
        const propertyControls = propertyControlArray.controls;
        this.showPropertyForm = true;
        if (propertyControls.length > 0) {
            const dialogRef = this.modalService.open(PopUpComponent, this.modalOptions);
            dialogRef.componentInstance.title = title;
            dialogRef.componentInstance.contentMessage = contentMessage;
            dialogRef.componentInstance.data = true;
            dialogRef.result.then((replaceData) => {
                if (replaceData) {
                    propertyControlArray.clear();
                    this.mapComponent.clearGraphics("Building plans inspectorate graphics");
                    this.setPropertyData(property.attributes, property.geometry);
                }
            });
        }
        else {
            this.setPropertyData(property.attributes, property.geometry);
        }
    }
    setPropertyData(propertyAttributes, geometry) {
        this.requestStatusService.showBusySpinner("GetPropertyData");
        try {
            this.showPropertyForm = true;
            const sgCode = CreateApplicationUtils.propertyDataAlternateColumnName(propertyAttributes, "SgCode", "sgcode");
            const duplicateFound = CreateApplicationUtils.checkIfPropertyIsADuplicate(sgCode, this.getProperties, this.appController, this.requestStatusService);
            if (!duplicateFound) {
                const newPropertyFormGroup = this.createNewPropertyFormGroup(propertyAttributes, sgCode, geometry);
                this.applicationCreateService.getPropertyCentroidObservable(geometry).subscribe({
                    next: (trueCentroidResponse) => {
                        CreateApplicationUtils.handleTrueCentroidResponse(trueCentroidResponse, newPropertyFormGroup);
                        this.setPropertyTabs(newPropertyFormGroup);
                        this.syncMapGeometries();
                        this.requestStatusService.removeBusySpinner("GetPropertyData");
                    },
                    error: (error) => {
                        this.requestStatusService.removeBusySpinner("GetPropertyData");
                        this.appController.handleServerErrorMessage(CreateApplicationLocationBpiConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                    }
                });
            }
        }
        catch (e) {
            this.appController.handleServerErrorMessage("getTrueCentroid", e, CRUDOperation.Get);
            this.requestStatusService.showBusySpinner("GetPropertyData");
        }
    }
    setPropertyTabs(newPropertyFormGroup) {
        const propertyControl = this.getProperties;
        propertyControl.push(newPropertyFormGroup);
        this.updatePropertyRequiredFields();
        this.changeDetectorRefs.detectChanges();
    }
    handleApplicationHasReferenceNumber() {
        this.showReferenceNumber = true;
        this.propertiesForm.get(this.bpamsReferenceLookupTypeControl).reset();
        this.propertiesForm.get(this.bpamsReferenceLookupTypeControl).setValue(this.lookupTypeBuildingPlanReference);
        this.propertiesForm.get(this.bpamsReferenceLookupTypeControl).addValidators(Validators.required);
        this.propertiesForm.get(this.bpamsReferenceNumberControl).reset();
        this.propertiesForm.get(this.bpamsReferenceNumberControl).enable();
        this.updateReferenceLookupValidators();
        this.propertiesForm.get(this.descriptionFormControlName).reset();
        this.propertiesForm.get(this.descriptionFormControlName).enable();
        this.showDescriptionField = true;
        this.propertiesForm.get(this.isVerifiedFormControlName).reset();
        this.propertiesForm.get(this.bpamsApplicationIdFormControlName).reset();
        this.propertiesForm.get(this.bpamsApplicationIdFormControlName).addValidators(Validators.required);
    }
    handleApplicationHasNoReferenceNumber() {
        this.showReferenceNumber = false;
        this.propertiesForm.get(this.bpamsReferenceLookupTypeControl).reset();
        this.propertiesForm.get(this.bpamsReferenceLookupTypeControl).clearValidators();
        this.propertiesForm.get(this.bpamsReferenceNumberControl).reset();
        this.propertiesForm.get(this.bpamsReferenceNumberControl).clearValidators();
        this.propertiesForm.get(this.erfNumberLookupControl).reset();
        this.propertiesForm.get(this.erfNumberLookupControl).clearValidators();
        this.propertiesForm.get(this.farmNumberLookupControl).reset();
        this.propertiesForm.get(this.farmNumberLookupControl).clearValidators();
        this.propertiesForm.get(this.portionNumberLookupControl).reset();
        this.propertiesForm.get(this.portionNumberLookupControl).clearValidators();
        this.propertiesForm.get(this.allotmentLookupControl).reset();
        this.propertiesForm.get(this.allotmentLookupControl).clearValidators();
        // this.propertiesForm.get(this.bpamsReferenceNumberControl).disable();
        this.showDescriptionField = true;
        this.propertiesForm.get(this.descriptionFormControlName).reset();
        this.propertiesForm.get(this.descriptionFormControlName).addValidators(Validators.required);
        this.propertiesForm.get(this.descriptionFormControlName).enable();
        this.propertiesForm.get(this.isVerifiedFormControlName).setValue(false);
        this.propertiesForm.get(this.bpamsApplicationIdFormControlName).setValue(null);
        this.propertiesForm.get(this.bpamsApplicationIdFormControlName).clearValidators();
        this.showPropertyForm = false;
        this.getProperties.clear();
        this.updateReferenceLookupControlsValidity();
    }
    createNewPropertyFormGroup(propertyAttributes, sgCode, geometry) {
        return new FormGroup({
            id: new FormControl(0),
            erfNo: new FormControl(CreateApplicationUtils.propertyDataAlternateColumnName(propertyAttributes, "ErfNo", "erfno"), [Validators.required]),
            subdivision: new FormControl(CreateApplicationUtils.propertyDataAlternateColumnName(propertyAttributes, "PtnNum", "ptnnum"), [Validators.required]),
            allotment: new FormControl(CreateApplicationUtils.propertyDataAlternateColumnName(propertyAttributes, "Allotment", "allotment"), [Validators.required]),
            farmNo: new FormControl(CreateApplicationUtils.propertyDataAlternateColumnName(propertyAttributes, "FarmNo", "farmno"), [Validators.required]),
            sgCode: new FormControl(sgCode, [Validators.required]),
            address: new FormControl(CreateApplicationUtils.propertyDataAlternateColumnName(propertyAttributes, "Address", "address"), [Validators.required]),
            erfSize: new FormControl(CreateApplicationUtils.propertyDataAlternateColumnName(propertyAttributes, "ErfSize", "erfsize"), [Validators.required]),
            geometry: new FormControl(geometry),
            centroid: new FormControl(null, [Validators.required]),
            owners: new FormControl(null, [Validators.required])
        });
    }
    createFormGroup(property, geom) {
        if (property.owners && property.owners.length > 0) {
            property.owners.forEach((owner) => {
                owner.id = 0;
                delete owner.jobId;
                delete owner.createdDate;
                delete owner.createdUserId;
                delete owner.lastEditedUserId;
                if (owner.groups && owner.groups.length > 0) {
                    owner.groups.forEach((g) => {
                        let groups = {};
                        groups = [];
                        const group = {};
                        group.groupName = g.groupName;
                        group.groupType = g.groupType;
                        groups.push(group);
                        owner.groups = groups;
                    });
                }
            });
        }
        const newProperty = new FormGroup({
            id: new FormControl(property.id),
            property: new FormControl(property),
            erfNo: new FormControl(property.erfNumber, [Validators.required]),
            subdivision: new FormControl(property.subdivision, [Validators.required]),
            allotment: new FormControl(property.allotment, [Validators.required]),
            farmNo: new FormControl(property.farmNumber, [Validators.required]),
            sgCode: new FormControl(property.sgCode, [Validators.required]),
            address: new FormControl(property.address, [Validators.required]),
            erfSize: new FormControl(property.erfSize, [Validators.required]),
            geometry: new FormControl(geom),
            centroid: new FormControl(null, [Validators.required]),
            owners: new FormControl(property.owners, [Validators.required])
        });
        newProperty.controls.sgCode.disable();
        newProperty.controls.erfNo.disable();
        newProperty.controls.farmNo.disable();
        newProperty.controls.subdivision.disable();
        newProperty.controls.allotment.disable();
        newProperty.controls.address.disable();
        newProperty.controls.erfSize.disable();
        return newProperty;
    }
    setTrueCentroid(geometryArc, newPropertiesFormGroup, propertiesFormArray, application) {
        const proxyUrl = ApiProxyConstants.URL;
        const gpToolUrl = AppConfig.settings.arcGIS.servicesURL + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
        const url = `${proxyUrl}?${gpToolUrl}`;
        const formData = new FormData();
        formData.append("f", "json");
        formData.append("geometryJSON", JSON.stringify(geometryArc));
        this.getTrueCentroidSubscription = this.applicationCreateService.getTrueCentroid(url, formData).subscribe({
            next: (response) => {
                newPropertiesFormGroup.get(this.centroidFormControlName).setValue(response.results[0].value);
                propertiesFormArray.push(newPropertiesFormGroup);
                this.syncMapGeometries();
                this.showPropertyForm = true;
                this.changeDetectorRefs.markForCheck();
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationLocationBpiConstants.TRUE_CENTROID, error, CRUDOperation.Get);
            }
        });
    }
    resetApplicationComponents() {
        this.aflaModuleStrategyService.previousApplication = null;
        this.mapComponent.removeGraphicsFromMap("Building plans inspectorate graphics");
        this.mapTools.sketchGraphicsLayer.removeAll();
        this.aflaModuleStrategyService.form.get(this.applicantFormGroupName).get(this.applicantFormControlName).enable();
        this.aflaModuleStrategyService.form.get(this.applicantFormGroupName).reset();
        this.aflaModuleStrategyService.form.get(this.applicantFormGroupName).updateValueAndValidity();
        this.aflaModuleStrategyService.form.get(this.applicantAgentFormGroupName).get(this.applicantAgentFormControlName).enable();
        this.aflaModuleStrategyService.form.get(this.applicantAgentFormGroupName).reset();
        this.aflaModuleStrategyService.form.get(this.applicantAgentFormGroupName).updateValueAndValidity();
        this.aflaModuleStrategyService.form.get(this.documentsFormGroupName).reset();
    }
    updatePropertyRequiredFields() {
        const items = this.propertiesForm.get(this.propertiesFormControlName);
        if (items.controls.length > 0) {
            const newProperty = items.controls[0];
            const erfNoControl = newProperty.get(this.erfNoControl);
            const farmNoControl = newProperty.get(this.farmNoControl);
            const subdivisionControl = newProperty.get(this.subdivisionControl);
            if (erfNoControl.value !== undefined && erfNoControl.value !== null && erfNoControl.value.trim() !== "") {
                erfNoControl.setValidators(Validators.required);
                farmNoControl.clearValidators();
                subdivisionControl.clearValidators();
                farmNoControl.setValue("");
                subdivisionControl.setValue("");
                farmNoControl.disable();
                subdivisionControl.disable();
                subdivisionControl.markAsUntouched();
                farmNoControl.markAsUntouched();
                this.subdivisionControlRequired = false;
                this.farmNoControlRequired = false;
                this.erfNoControlRequired = true;
            }
            else if ((farmNoControl.value !== undefined && farmNoControl.value !== null && farmNoControl.value.trim() !== "") || (subdivisionControl.value !== undefined && subdivisionControl.value !== null && subdivisionControl.value.trim() !== "")) {
                farmNoControl.setValidators(Validators.required);
                subdivisionControl.setValidators(Validators.required);
                erfNoControl.clearValidators();
                erfNoControl.setValue("");
                erfNoControl.disable();
                erfNoControl.markAsUntouched();
                this.subdivisionControlRequired = true;
                this.farmNoControlRequired = true;
                this.erfNoControlRequired = false;
            }
            else {
                erfNoControl.setValidators(Validators.required);
                farmNoControl.setValidators(Validators.required);
                subdivisionControl.setValidators(Validators.required);
                erfNoControl.enable();
                farmNoControl.enable();
                subdivisionControl.enable();
                erfNoControl.markAsUntouched();
                subdivisionControl.markAsUntouched();
                farmNoControl.markAsUntouched();
                this.subdivisionControlRequired = true;
                this.farmNoControlRequired = true;
                this.erfNoControlRequired = true;
            }
            const sgCodeControl = newProperty.get(this.sgCodeControl);
            if (sgCodeControl.value !== null && sgCodeControl.value !== undefined && sgCodeControl.value !== "") {
                sgCodeControl.disable();
            }
            else {
                sgCodeControl.enable();
            }
            erfNoControl.updateValueAndValidity();
            farmNoControl.updateValueAndValidity();
            subdivisionControl.updateValueAndValidity();
            this.changeDetectorRefs.detectChanges();
        }
    }
    updateReferenceLookupValidators() {
        const bpamsReferenceNumberControl = this.propertiesForm.get(this.bpamsReferenceNumberControl);
        const erfNumberControl = this.propertiesForm.get(this.erfNumberLookupControl);
        const farmNumberControl = this.propertiesForm.get(this.farmNumberLookupControl);
        const portionNumberControl = this.propertiesForm.get(this.portionNumberLookupControl);
        const allotmentControl = this.propertiesForm.get(this.allotmentLookupControl);
        const lookupType = this.propertiesForm.get(this.bpamsReferenceLookupTypeControl).value;
        bpamsReferenceNumberControl.clearValidators();
        erfNumberControl.clearValidators();
        farmNumberControl.clearValidators();
        portionNumberControl.clearValidators();
        allotmentControl.clearValidators();
        if (lookupType === this.lookupTypeBuildingPlanReference) {
            bpamsReferenceNumberControl.setValidators(Validators.required);
        }
        else if (lookupType === this.lookupTypeErfNumber) {
            erfNumberControl.setValidators(Validators.required);
            allotmentControl.setValidators(Validators.required);
        }
        else if (lookupType === this.lookupTypeFarmNumber) {
            farmNumberControl.setValidators(Validators.required);
            portionNumberControl.setValidators(Validators.required);
            allotmentControl.setValidators(Validators.required);
        }
        this.updateReferenceLookupControlsValidity();
    }
    updateReferenceLookupControlsValidity() {
        this.propertiesForm.get(this.bpamsReferenceLookupTypeControl).updateValueAndValidity();
        this.propertiesForm.get(this.bpamsReferenceNumberControl).updateValueAndValidity();
        this.propertiesForm.get(this.erfNumberLookupControl).updateValueAndValidity();
        this.propertiesForm.get(this.farmNumberLookupControl).updateValueAndValidity();
        this.propertiesForm.get(this.portionNumberLookupControl).updateValueAndValidity();
        this.propertiesForm.get(this.allotmentLookupControl).updateValueAndValidity();
    }
    loadPropertyAllotments() {
        const propertyModuleMap = this.mapService.userMaps.find(a => a.selectionLayerType?.toLowerCase() === "property");
        if (propertyModuleMap !== undefined && propertyModuleMap !== null && propertyModuleMap.layer !== undefined && propertyModuleMap.layer !== null) {
            const propertyLayer = propertyModuleMap.layer;
            const propertyQuery = propertyLayer.createQuery();
            propertyQuery.where = "1=1";
            propertyQuery.returnGeometry = false;
            propertyQuery.outFields = ["Allotment"];
            propertyQuery.returnDistinctValues = true;
            propertyQuery.orderByFields = ["Allotment"];
            propertyLayer.queryFeatures(propertyQuery).then((propertyFeatureSet) => {
                const allotmentList = [];
                if (propertyFeatureSet?.features?.length > 0) {
                    propertyFeatureSet.features.forEach(item => {
                        const allotment = CreateApplicationUtils.propertyDataAlternateColumnName(item.attributes, "Allotment", "allotment");
                        if (allotment !== null && allotment !== undefined && allotment !== "" && allotmentList.indexOf(allotment) === -1) {
                            allotmentList.push(allotment);
                        }
                    });
                }
                this.allotmentOptions = allotmentList.sort();
                this.changeDetectorRefs.detectChanges();
            });
        }
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: MapService },
        { type: MapTools },
        { type: RequestStatusService },
        { type: ChangeDetectorRef },
        { type: NgbModal },
        { type: BuildingPlansInspectorateService },
        { type: SearchApplicationsService },
        { type: UserInformationService }
    ];
    static propDecorators = {
        ownersComponentRef: [{ type: ViewChild, args: [RecipientSelectComponent,] }],
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
CreateApplicationLocationBpiComponent = __decorate([
    Component({
        selector: "app-create-application-location-bpi",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationLocationBpiComponent);
export { CreateApplicationLocationBpiComponent };
